/** ARCA badge + CTA helpers (SPEC-15). */

export const ARCA_STATUS_COPY = {
  valid: ['ARCA · Validado', 'success'],
  observed: ['ARCA · Observado', 'warn'],
  rejected: ['ARCA · Posible fraude', 'error'],
  error: ['ARCA · Error al validar', 'warn'],
  skipped_missing_fields: ['ARCA · Datos insuficientes', 'warn'],
  not_enabled: ['ARCA · Desactivado', 'muted'],
  pending: ['ARCA · Validando', 'pending'],
  sin_constatar: ['ARCA · Sin constatar', 'muted'],
};

function bedrockSignals(bedrock = {}) {
  const tipo = String(bedrock.tipo_documento || bedrock.categoria_documento || '').toLowerCase();
  if (/factura|nota de cr|nota de d|d[eé]bito|cr[eé]dito|invoice/.test(tipo)) return true;
  if (bedrock.CAE || bedrock.codigo_factura || bedrock['codigo factura']) return true;
  return false;
}

export function isArcaEligibleDocument(row = {}) {
  const status = String(row.status || '').toUpperCase();
  if (status !== 'PROCESS_COMPLETED' && status !== 'PROCESS_PARTIALLY_COMPLETED') {
    return false;
  }
  const docType = String(row.doc_type || '').toLowerCase();
  if (['invoice', 'invoices'].includes(docType)) return true;
  if (docType === 'unclassified' && bedrockSignals(row.bedrock_model_output || {})) return true;
  return bedrockSignals(row.bedrock_model_output || {});
}

export function isArcaEligibleQueueItem(item = {}) {
  if (item.status !== 'done') return false;
  if (item.comprobante_subtype && item.comprobante_subtype !== 'OTROS') return true;
  const docType = String(item.doc_type || '').toLowerCase();
  if (['invoice', 'invoices'].includes(docType)) return true;
  return bedrockSignals(item.bedrock_model_output || {});
}

export function resolveArcaDisplay(validation, row, { enabled = false } = {}) {
  if (!enabled) return null;
  if (!isArcaEligibleDocument(row) && !isArcaEligibleQueueItem(row)) return null;

  const status = validation?.status;
  if (status && ARCA_STATUS_COPY[status]) {
    const [label, tone] = ARCA_STATUS_COPY[status];
    return {
      label,
      tone,
      status,
      showConstatar: !['valid', 'pending'].includes(status),
    };
  }

  return {
    label: ARCA_STATUS_COPY.sin_constatar[0],
    tone: ARCA_STATUS_COPY.sin_constatar[1],
    status: 'sin_constatar',
    showConstatar: true,
  };
}
